import React from 'react';
import './SchedaCarriera.css';

/**
 * L'impianto delle due schede. Su desktop la colonna identità sta a sinistra e resta ferma
 * mentre si scorre il contenuto; su telefono è semplicemente il primo blocco della pila.
 */
export default function SchedaCarriera({ titolo, codice, sottotitolo, kpi, lato, children }) {
  return (
    <div className="scheda-carriera">
      <aside className="scheda-identita">
        <h1 className="scheda-titolo">{titolo}</h1>
        {codice}
        {sottotitolo ? <p className="scheda-sottotitolo">{sottotitolo}</p> : null}
        {kpi}
        {lato}
      </aside>
      <div className="scheda-contenuto">{children}</div>
    </div>
  );
}
